import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M21.54 1.88A24.1 24.1 0 0 0 12 0a24.1 24.1 0 0 0-9.54 1.88A2.47 2.47 0 0 0 1 4.14v7.3a12.85 12.85 0 0 0 8.5 11.9l1.08.39A4.2 4.2 0 0 0 12 24a4.3 4.3 0 0 0 1.46-.26l1.07-.39A12.84 12.84 0 0 0 23 11.44v-7.3a2.47 2.47 0 0 0-1.46-2.26"
    }, null, -1)
  ]));
}
const basicShapeShield = { render };
export {
  basicShapeShield as default,
  render
};
//# sourceMappingURL=basic-shape-shield.svg.js.map
